import { useEffect } from "react";

// Keys puede ser un array o un string
function useKeyPress(keys, callback) {
  useEffect(() => {
    const onKeyDown = ({ key }) => {
      if (Array.isArray(keys) ? keys.includes(key) : keys === key) callback();
    };
    if (callback) {
      window.addEventListener("keydown", onKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [callback, keys]);
}

export default useKeyPress;
